import { render, staticRenderFns } from "./property-results-map-list.vue?vue&type=template&id=35adbb2c&scoped=true&"
import script from "./property-results-map-list.vue?vue&type=script&lang=ts&"
export * from "./property-results-map-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35adbb2c",
  null
  
)

export default component.exports